import { createFileRoute } from '@tanstack/react-router';
import { FormsHubPage } from '@/features/forms/forms-hub-page';

export const Route = createFileRoute('/w/$workspaceId/forms/')({ component: FormsHubPage });
